import { CgScrollV } from "react-icons/cg";

const ScrollToTopWidget = () => {
	return(
		<button className="btn btn-sm btn-primary m-5 top-widget position-fixed bottom-0 end-0 d-none d-xl-block" onClick={() => window.scrollTo(0, 0)}><CgScrollV/> Top</button>
	);
};

export default ScrollToTopWidget;